var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSeedProduct(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.80548 4.33362C8.39412 3.95478 8.39874 3.0506 7.81581 2.31406C7.23288 1.57752 6.28315 1.28755 5.69452 1.66638C5.10589 2.04522 5.10126 2.9494 5.68419 3.68594C6.26712 4.42248 7.21685 4.71245 7.80548 4.33362Z",
    fill: "#0C612C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.55034 10.0145C9.96303 9.40422 9.71539 8.45534 8.99724 7.89507C8.27908 7.33481 7.36235 7.37531 6.94966 7.98555C6.53697 8.59578 6.78461 9.54466 7.50276 10.1049C8.22092 10.6652 9.13765 10.6247 9.55034 10.0145Z",
    fill: "#0C612C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6842 5.31406C11.1013 6.0506 11.1059 6.95478 11.6945 7.33362C12.2831 7.71245 13.2329 7.42248 13.8158 6.68594C14.3987 5.9494 14.3941 5.04522 13.8055 4.66638C13.2169 4.28755 12.2671 4.57752 11.6842 5.31406Z",
    fill: "#0C612C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.25 9.75C1.42157 9.75 0.75 10.4216 0.75 11.25V17.25H17.25V11.25C17.25 10.4216 16.5784 9.75 15.75 9.75H14.0856C13.3911 9.75 12.8586 10.2105 12.6134 10.7178C12.277 11.4141 11.3547 12.75 9 12.75C6.6453 12.75 5.72301 11.4141 5.38656 10.7178C5.14143 10.2105 4.60895 9.75 3.91442 9.75H2.25ZM2.25 15.75V11.25H3.91444C3.91444 11.25 3.91708 11.25 3.92248 11.2518C3.92847 11.2538 3.93888 11.2584 3.95248 11.2681C3.98159 11.2886 4.01367 11.3243 4.03596 11.3704C4.53514 12.4035 5.8926 14.25 9 14.25C12.1074 14.25 13.4649 12.4035 13.964 11.3704C13.9863 11.3243 14.0184 11.2886 14.0475 11.2681C14.0611 11.2584 14.0715 11.2538 14.0775 11.2518C14.0829 11.25 14.0856 11.25 14.0856 11.25H15.75V15.75H2.25Z",
    fill: "#0C612C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeedProduct);
export default __webpack_public_path__ + "static/media/seedProduct.34bf443083a3063e3d0d4706a538d583.svg";
export { ForwardRef as ReactComponent };